<script lang="ts">
	import MultiplePageLayout from "@hitit/hub/src/layouts/MultiplePageLayout.svelte";
	import SalesHistory from "./SalesHistory.svelte";
	import SalesCalendar from "./SalesCalendar.svelte";
	import ContainerLoading from "../components/common/ContainerLoading.svelte";
	import { navigate, Router, Route } from "svelte-routing";
	import { t } from "../../stores";
	import { onDestroy } from "svelte";
	import { popup, saveStatus } from "../store";

	export let storeId = "";
	//Constants

	const headerInfos = [
		{
			title: $t("hub.order.sales_history"),
			clickEvent: () => navigate("/revenue/saleshistory"),
			route: "/revenue/saleshistory/*",
		},
		{
			title: $t("hub.order.sales_calendar"),
			clickEvent: () => navigate("/revenue/salescalendar"),
			route: "/revenue/salescalendar/*",
		},
	];
	onDestroy(() => {
		$popup = undefined;
	});

</script>

<MultiplePageLayout headerInfos={headerInfos}>
	{#if $saveStatus.options}
		<ContainerLoading>
			<p id="save-status">{$t('global.saving_changes')}</p>
		</ContainerLoading>
	{/if}
	<Router>
		<Route path="/saleshistory">
			<SalesHistory storeId={storeId} />
		</Route>
		<Route path="/salescalendar">
			<SalesCalendar storeId={storeId} />
		</Route>
	</Router>
</MultiplePageLayout>

<style lang="scss">
	#save-status {
		font-size: 1.25rem;
		color: #46474b;
	}

</style>
